import { render, staticRenderFns } from "./UnpaidDebtorList.vue?vue&type=template&id=d1e2bd8c&scoped=true"
import script from "./UnpaidDebtorList.vue?vue&type=script&lang=js"
export * from "./UnpaidDebtorList.vue?vue&type=script&lang=js"
import style0 from "./UnpaidDebtorList.vue?vue&type=style&index=0&id=d1e2bd8c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1e2bd8c",
  null
  
)

export default component.exports